import { GlobalContext } from '@/context';
import { CopyToClipboard } from '@/scripts';
import { BrandType } from '@/types';
import { Button, message } from 'antd';
import Image from 'next/image';
import { useContext } from 'react';
import { FaStar } from 'react-icons/fa';
import { IoShareSocialOutline } from 'react-icons/io5';
import { __BrandSocials } from '../brandDetail.scripts';
import styles from './brandInfo.module.scss';
function BrandInfoCom({
  data
}: {
  data: BrandType;
}) {
  const lang = useContext(GlobalContext).langText.brandInfo;
  const handleCopyToClipboard = () => {
    CopyToClipboard(window.location.href);
    message.success(lang.copy_alert);
  };
  return <div className={`${styles['info']} flex-column pv-3 ph-4 ${!data.gallery || data.gallery.length === 0 ? styles['full-width'] : ''}`} data-sentry-component="BrandInfoCom" data-sentry-source-file="brandInfo.index.tsx">
            <div className="d-flex gap-16">
                <Image src={data.main_image ? data.main_image.file : data.gallery?.length ? data.gallery[0].file : ''}
      // alt={
      //     data.main_image?.alt
      //         ? data.main_image.alt
      //         : data.gallery?.length
      //           ? data.gallery[0].alt ?? ''
      //           : ''
      // }
      alt={`${data.title} brand logo`} width={80} height={80} data-sentry-element="Image" data-sentry-source-file="brandInfo.index.tsx" />
                <div className="w-100 d-flex justify-content-between">
                    <div>
                        <h1 className="t-h4 t-dark1 t-700 mb-1">{data.title}</h1>
                        <span className="d-flex gap-8">
                            {data.average_stars && <p className="t-400 t-p1 t-primary">
                                    {data.average_stars?.toFixed(2)} <FaStar size={14} />
                                </p>}
                            <p className="t-400 t-p1 t-dark4">
                                {data.total_orders} {lang.sale}
                            </p>
                        </span>
                    </div>
                    <Button type="primary" className="d-pre-md-none-i" onClick={handleCopyToClipboard} data-sentry-element="Button" data-sentry-source-file="brandInfo.index.tsx">
                        <IoShareSocialOutline size={24} data-sentry-element="IoShareSocialOutline" data-sentry-source-file="brandInfo.index.tsx" />
                    </Button>
                </div>
            </div>
            <p dangerouslySetInnerHTML={{
      __html: data.description
    }} className={`${styles['desc']} mv-3`}></p>
            <span className="flex-1" />
            <div className={`${styles['contacts']} d-flex gap-16`}>
                <div className={`pv-2 ph-3 ${!data.phone && !data.mobile ? 'd-none' : ''}`}>
                    <p className="t-p1 t-700 t-dark1 mb-2">{lang.contact_numbers}</p>
                    <div className={`${styles['list']} mv-0`}>
                        {data.phone?.split('\r\n').map((phone: string, index: number) => <span key={index}>{phone}</span>)}
                        {data.mobile?.split('\r\n').map((phone: string, index: number) => <span key={index}>{phone}</span>)}
                    </div>
                </div>
                <div className={`pv-2 ph-3 ${!data.address ? 'd-none' : ''}`}>
                    <p className="t-span1 t-700 t-dark1 mb-2">{lang.address}</p>
                    <span style={{
          display: 'inline-block'
        }} className="t-400 t-p1 t-dark2 ltr-i">
                        {data.address ?? ''}
                    </span>
                </div>
            </div>
            <div className={`${styles['socials']} d-flex justify-content-between align-items-center ph-3 
                ${__BrandSocials(data).filter(i => i.link.length > 0).length === 0 ? 'd-none-i' : ''}`}>
                <p className="t-700 t-p1 t-dark1">{lang.social_networks}</p>
                <span className="d-flex">
                    {__BrandSocials(data).map((item, index) => <a aria-label={item.socialName} target="_blank" className={`${!item.link?.length ? 'd-none' : ''}`} href={item.link ?? ''} key={index}>
                            <item.icon size={24} />
                        </a>)}
                </span>
            </div>
            <p className="d-none d-pre-md-flex t-400 t-p1 t-dark4 align-items-center gap-8 mt-3" onClick={handleCopyToClipboard}>
                <IoShareSocialOutline size={17} data-sentry-element="IoShareSocialOutline" data-sentry-source-file="brandInfo.index.tsx" /> {lang.share}
            </p>
        </div>;
}
export default BrandInfoCom;